export default "__VITE_ASSET__1c74e6f2__"